import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from "./authinterceptor";
import AuthHeader from "../services/auth.header";

const API_URL = process.env.REACT_APP_LOCALHOST_URL + "/api/auth/";

export const login = createAsyncThunk('auth/login', async (loginObj) => {
  console.log("U P:", loginObj.username, loginObj.password);
  const username = loginObj.username;
  const password = loginObj.password;
  const response = await axios.post(API_URL + "signin", {
    username,
    password,
  });
  console.log(response);

  return response.data;
});

export const reloadUser = createAsyncThunk('auth/reloadUser', async (loginObj) => {
  const response = await axios.get(API_URL + "reloadUser", { headers: AuthHeader.authHeader() });
  console.log("RELOADED USER-----------------", response);

  return response.data;
});

export const reloadSubsite = createAsyncThunk('auth/reloadSubsite', async (loginObj) => {
  const response = await axios.get(API_URL + "reloadSubsite", { headers: AuthHeader.authHeader() });
  console.log(response);

  return response.data;
});

export const loadSubsite = createAsyncThunk('subsite/get', async (subsiteId) => {
  const response = await axios.get(process.env.REACT_APP_LOCALHOST_URL + "/api/subsite/" + subsiteId);
  console.log(response);
  return response.data;
});


export const register = createAsyncThunk('auth/register', async (registerObj) => {
  console.log(registerObj);
  const response = await axios.post(API_URL + "register", {
    registerObj
  });
  console.log(response);

  return response.data;
});

export const requestRegister = createAsyncThunk('auth/requestregister', async (registerObj) => {
  console.log(registerObj);
  const response = await axios.post(API_URL + "requestregister", {
    registerObj
  });
  console.log(response);

  return response.data;
});

export const confirm = createAsyncThunk('auth/confirm', async (id) => {
  console.log(id);
  const response = await axios.post(API_URL + "confirm", {
    regId: id
  });
  console.log(response);

  return response.data;
});

export const getRegistration = createAsyncThunk('auth/register', async (id) => {
  const response = await axios.get(API_URL + "register/" + id);
  console.log(response);
  return response.data;
});

export const getRetailSubsite = createAsyncThunk('subsite/retail', async (subsiteId) => {
  const response = await axios.get(process.env.REACT_APP_LOCALHOST_URL + "/api/subsite/" + subsiteId);
  console.log(response);
  return response.data;
});

export const checkIsAdmin = (role, capabilities, state) => {
  if (role) {
    if (role.roleName === "super") {
      state.isSuperAdmin = true;
      state.isAdmin = true;
    } else if (role.roleName === "siteadmin") {
      state.isAdmin = true;
    } else if (role.roleName === "supervisor") {
      state.isSupervisor = true;
    } else if (role.roleName === "manager") {
      state.isManager = true;
    }
  }
  // Admin section is gated on admin capabilities only (ADD_USER, etc.),
  // not product/visibility capabilities (TIER_*, Supervisor, etc.).
  state.hasCapabilities = !!(capabilities && capabilities.length > 0);
}

export const getUser = state => state.auth.user;
export const getRegisterUser = state => state.auth.registerUser;
export const getSubsite = state => state.auth.currentSubsite;
export const getSubsiteBalance = state => state.auth.currentSubsiteBalance;
export const getSubsiteStatus = state => state.auth.subsiteStatus;
export const getRetailStatus = state => state.auth.retailStatus;
export const isLoggedIn = state => state.auth.isLoggedIn;
export const message = state => state.auth.error;
export const isAdmin = state => state.auth.isAdmin;
export const isSuperAdmin = state => state.auth.isSuperAdmin;
export const isSupervisor = state => state.auth.isSupervisor;
export const isManager = state => state.auth.isManager;
export const hasCapabilities = state => state.auth.hasCapabilities;
export const getUserCapabilities = state => state.auth.capabilities;
export const getUserProductCapabilities = state => state.auth.productCapabilities;
export const getNhKGate = state => state.auth.nhkGate;
export const isNhKLocked = state => state.auth.nhkGate && state.auth.nhkGate.status === 'locked';

const initialState = {
  isLoggedIn: false,
  isAdmin: false,
  isSuperAdmin: false,
  isSupervisor: false,
  isManager: false,
  hasCapabilities: false,
  capabilities: [],
  productCapabilities: [],
  user: {},
  registerUser: {},
  currentSubsite: {},
  currentSubsiteBalance: {},
  nhkGate: { status: 'unlocked', deadlineAt: null, daysLeft: null, requireNewHireKit: false },
  status: 'idle',
  subsiteStatus: 'idle',
  retailStatus: 'idle',
  error: null
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    logout(state, action) {
      console.log("IS LOGGING OUT", action.payload);
      state.user = {};
      state.isLoggedIn = false;
      state.isAdmin = false;
      state.isSuperAdmin = false;
      state.isSupervisor = false;
      state.isManager = false;
      state.hasCapabilities = false;
      state.capabilities = [];
      state.productCapabilities = [];
      state.nhkGate = { status: 'unlocked', deadlineAt: null, daysLeft: null, requireNewHireKit: false };
      localStorage.clear();
      sessionStorage.clear();
      state.error = "";
      window.location.href = "/login?message=" + action.payload;
    },
    notFound(state, action) {
      window.location.href = "/notfound";
    },
    setSubsite(state, action) {
      console.log("SET SUBSITE", action.payload);

      state.currentSubsite = action.payload.subsite;
      state.subsiteStatus = 'subsite' + action.payload.subsite.id;

      state.isSuperAdmin = false;
      state.isAdmin = false;
      state.isSupervisor = false;
      state.isManager = false;
      state.hasCapabilities = false;
      state.capabilities = action.payload.capabilities || [];
      state.productCapabilities = action.payload.productCapabilities
        || action.payload.product_capabilities
        || [];

      if (action.payload.role) {
        checkIsAdmin(action.payload.role, state.capabilities, state);
      }
      console.log("CURRENT CAPABILITIES", state.capabilities);
      console.log("CURRENT PRODUCT CAPABILITIES", state.productCapabilities);
      console.log("CURRENT IS ADMIN", state.isAdmin);

    },
    updateEmailPrefs(state, action) {
      console.log("UPDATE EMAIL PREFS", action.payload);
      state.user.email_pref = { "allEmails": action.payload.allEmails, "poEmails": action.payload.poEmails, "dailyEmails": action.payload.dailyEmails };
    }
  },
  extraReducers(builder) {
    builder
      .addCase(login.pending, (state, action) => {
        if (state.error != null) state.error = null;
        state.status = 'loading'
      })
      .addCase(login.fulfilled, (state, action) => {
        // Add any fetched posts to the array
        console.log("USER LOGGED IN", JSON.stringify(action.payload));
        state.user = action.payload.user;
        var user = action.payload.user;
        var currentRole = null;
        console.log("CURRENT SUBSITE FROM AUTH", action.payload.user.user_subsites[0].subsite);
        state.currentSubsite = action.payload.user.user_subsites[0].subsite;
        currentRole = action.payload.user.user_subsites[0].role;

        state.currentSubsiteBalance = user.subsite_balances[0];

        const membership = action.payload.user.user_subsites[0];
        state.capabilities = membership.capabilities || [];
        state.productCapabilities = membership.productCapabilities || membership.product_capabilities || [];
        state.isSuperAdmin = false;
        state.isAdmin = false;
        state.isSupervisor = false;
        state.isManager = false;
        state.hasCapabilities = false;

        if (currentRole) {
          checkIsAdmin(currentRole, state.capabilities, state);
        }
        state.nhkGate = action.payload.nhkGate || {
          status: 'unlocked', deadlineAt: null, daysLeft: null, requireNewHireKit: false
        };
        // Admins are never locked by the NHK gate
        if (state.isAdmin || state.isSuperAdmin) {
          state.nhkGate = { ...state.nhkGate, status: 'unlocked' };
        }
        state.isLoggedIn = true;
        state.status = 'succeeded';

        console.log("CURRENT CAPABILITIES", state.capabilities);
        console.log("CURRENT PRODUCT CAPABILITIES", state.productCapabilities);
        console.log("CURRENT IS ADMIN", state.isAdmin);

      })
      .addCase(login.rejected, (state, action) => {
        console.log("USER REJECTED", action);
        state.status = 'failed';
        state.error = "User or password incorrect";
      })
      .addCase(reloadUser.pending, (state, action) => {
        if (state.error != null) state.error = null;
        state.status = 'loading'
      })
      .addCase(reloadUser.fulfilled, (state, action) => {
        state.status = 'succeeded'
        // Add any fetched posts to the array
        console.log("USER LOGGED IN", action.payload);
        state.user = action.payload.user;
        var currentRole = null;
        var user = action.payload.user;

        state.currentSubsite = action.payload.user.user_subsites[0].subsite;
        currentRole = action.payload.user.user_subsites[0].role;

        state.currentSubsiteBalance = user.subsite_balances[0];

        const membership = action.payload.user.user_subsites[0];
        state.capabilities = membership.capabilities || [];
        state.productCapabilities = membership.productCapabilities || membership.product_capabilities || [];
        state.isSuperAdmin = false;
        state.isAdmin = false;
        state.isSupervisor = false;
        state.isManager = false;
        state.hasCapabilities = false;

        if (currentRole) {
          checkIsAdmin(currentRole, state.capabilities, state);
        }
        state.nhkGate = action.payload.nhkGate || {
          status: 'unlocked', deadlineAt: null, daysLeft: null, requireNewHireKit: false
        };
        if (state.isAdmin || state.isSuperAdmin) {
          state.nhkGate = { ...state.nhkGate, status: 'unlocked' };
        }
        state.isLoggedIn = true;
      })
      .addCase(reloadUser.rejected, (state, action) => {
        console.log("USER REJECTED", action);
        state.status = 'failed';
        state.error = null;
      })
      .addCase(reloadSubsite.pending, (state, action) => {
        if (state.error != null) state.error = null;
        state.status = 'loading'
      })
      .addCase(reloadSubsite.fulfilled, (state, action) => {
        state.currentSubsite = action.payload.subsite;
        state.status = 'succeeded';
      })
      .addCase(reloadSubsite.rejected, (state, action) => {
        console.log("RELOAD SUBSITE REJECTED", action);
        state.status = 'failed';
        state.error = null;
      })
      .addCase(getRetailSubsite.pending, (state, action) => {
        if (state.error != null) state.error = null;
        state.retailStatus = 'loading'
      })
      .addCase(getRetailSubsite.fulfilled, (state, action) => {
        state.retailStatus = 'succeeded'
        console.log("USER LOGGED IN", action.payload);
        state.currentSubsite = action.payload;
      })
      .addCase(getRetailSubsite.rejected, (state, action) => {
        console.log("USER REJECTED", action);
        state.retailStatus = 'failed';
        state.error = "Subsite is not Retail";
      })
      .addCase(loadSubsite.pending, (state, action) => {
        if (state.error != null) state.error = null;
      })
      .addCase(loadSubsite.fulfilled, (state, action) => {
        state.subsiteStatus = 'succeeded';
        console.log("RELOAD SUBSITE", action.payload);
        state.currentSubsite = action.payload;
      })
      .addCase(loadSubsite.rejected, (state, action) => {
        state.subsiteStatus = 'failed';
        state.error = "Subsite is not reloaded";
      })
      .addCase(getRegistration.fulfilled, (state, action) => {
        state.registerUser = action.payload.user;
        console.log("GET REGISTER USER", state.registerUser);
      })
  }
});

export const { logout, notFound, setSubsite, updateEmailPrefs } = authSlice.actions;
export default authSlice.reducer;